module.exports = __webpack_public_path__ + "48257907507e5c12ce836c233325775e.svg";